/* eslint-disable no-use-before-define */
const DEFAULTS = {
  duration: 300,
  done: () => {},
};

let globalOptions = {};

const isAnimatingStyle = {
  transition: 'opacity 500ms ease',
  display: '',
  opacity: 0,
};

const inStyle = {
  opacity: 1,
  display: 'block',
};

export default function fadeIn(el, options = DEFAULTS) {
  globalOptions = { ...DEFAULTS, ...options };
  isAnimatingStyle.transition = `opacity ${globalOptions.duration}ms ease`;
  animateIn(el);
}

function animateIn(el) {
  Object.assign(el.style, isAnimatingStyle);
  el.addEventListener('transitionend', removeTransition);
  el.getBoundingClientRect();
  window.requestAnimationFrame(() => {
    Object.assign(el.style, inStyle);
  });
}

function removeTransition(e) {
  if (e.target !== e.currentTarget) return;

  e.target.style.removeProperty('transition');
  e.target.removeEventListener('transitionend', removeTransition);
  globalOptions.done();
}
